import { configureStore } from '@reduxjs/toolkit'

import {
    ReducerDrawer, ReducerAuth, ReducerCustomer, ReducerCompanyForm, ReducerCreditPolicy,
    ReducerPlanGroup, ReducerUsageLog, ReducerBypassCustomer, ReducerCompanyCustomer,
    ReducerBatchFile
} from './reducers'


export default configureStore({
    reducer: {
        drawer: ReducerDrawer,
        auth: ReducerAuth,
        batchFiles: ReducerBatchFile,
        bypassCustomers: ReducerBypassCustomer,
        companyCustomer: ReducerCompanyCustomer,
        companyForm: ReducerCompanyForm,
        creditPolicies: ReducerCreditPolicy,
        customer: ReducerCustomer,
        planGroups: ReducerPlanGroup,
        usageLog: ReducerUsageLog
    },
    devTools: process.env.NODE_ENV !== 'production'
})
